import { getIdToken } from 'firebase/auth'

import { auth } from '../firebase/config'

/**
 * Get Firebase authentication token
 */
export const getAuthToken = async (): Promise<string> => {
  const { currentUser } = auth
  if (!currentUser) {
    throw new Error('No authenticated Firebase user found')
  }
  return getIdToken(currentUser)
}

